module.exports = __webpack_public_path__ + "img/table_he.69b25bb1.jpg";